import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './Login';
import HomePage from './HomePage';
import AboutPage from './AboutPage';
import Header from './Header';
import UserList from './GestioneUtenti';
import './Header.css';
import './table.css';
import { AuthProvider } from './AuthContext';
import CreaEvento from './CreaEvento';
import CreaUtente from './CreaUtente';
import EventList from './GestioneEventi';
import ProfilePage from './ProfilePage';
import ProfilePageAdmin from './ProfilePageAdmin';
import PrivateRoute from './PrivateRoute';
import GestioneLingue from './GestioneLingue';

const App = () => {
  return (
    <AuthProvider>
      <div>
        <Router>
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/login" element={<Login />} />

            <Route path="/crea" element={<PrivateRoute><CreaEvento /></PrivateRoute>} />
            <Route path="/events" element={<PrivateRoute><EventList /></PrivateRoute>} />
            <Route path="/profile" element={<PrivateRoute><ProfilePage /></PrivateRoute>} />

            <Route
              path="/creaUtente"
              element={
                <PrivateRoute requiredRole="ROLE_ADMIN">
                  <CreaUtente />
                </PrivateRoute>
              }
            />
            <Route
              path="/listaUtenti"
              element={
                <PrivateRoute requiredRole="ROLE_ADMIN">
                  <UserList />
                </PrivateRoute>
              }
            />
            <Route
              path="/user/:id"
              element={
                <PrivateRoute requiredRole="ROLE_ADMIN">
                  <ProfilePageAdmin />
                </PrivateRoute>
              }
            />
            <Route
              path="/package"
              element={
                <PrivateRoute requiredRole="ROLE_ADMIN">
                  <UserList />
                </PrivateRoute>
              }
            />
            <Route
              path="/lingue"
              element={
                <PrivateRoute requiredRole="ROLE_ADMIN">
                  <GestioneLingue />
                </PrivateRoute>
              }
            />
          </Routes>
        </Router>
      </div>
    </AuthProvider>
  );
};

export default App;
